import type { DocumentPayload } from '@Application/Beneficiaries/Documents/Actions/documentsFetched';
import VerificationProgressView from '@UI/Store/Documents/Views/VerificationProgressView';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One row of the documents tab. `documentTypeId` is read off the `documentType` relation (`{ id }`):
 * the label is resolved against `DocumentTypesListView.labelOf`, never carried here.
 */
class DocumentView {
	readonly id: number;
	readonly title: string;
	readonly documentTypeId: number;
	readonly createdAt: string;
	readonly status: LabeledValueView;
	readonly progress: VerificationProgressView;

	constructor(payload: DocumentPayload) {
		this.id = payload.id;
		this.title = payload.title;
		this.documentTypeId = payload.documentType.id;
		this.createdAt = payload.createdAt;
		this.status = new LabeledValueView(payload.status);
		this.progress = new VerificationProgressView(payload.progress);

		Object.freeze(this);
	}
}

export default DocumentView;
